(function ($) {
  Drupal.behaviors.quickshopCarouselSlideV1 = {
    isMobile: false,
    unisonReady: false,
    checkCarousel: function ($modules) {
      var isVirtualEvents = false;

      $modules.each(function () {
        if ($(this).hasClass('js-virtual-events')) {
          isVirtualEvents = true;
        }
      });

      return isVirtualEvents;
    },
    attach: function (context) {
      var self = this;
      var $modulesInit = $('.js-quickshop-carousel-slide', context);
      var $modules;
      var isVirutalEvents = this.checkCarousel($modulesInit);

      if (!!Unison.fetch.now()) {
        self.unisonReady = true;
      }
      Unison.on('change', function () {
        if (!self.attached) {
          self.attach(context);
        }
        if (self.unisonReady) {
          self.isMobile = parseInt(Unison.fetch.now().width, 10) < parseInt(Unison.fetch.all()['usn-medium'], 10);
        }
      });
      if (!self.unisonReady) {
        return;
      }
      /* To allow for events to be place on 'clone' slides,
       we must wait for the carousel to be initialised. */
      if (isVirutalEvents) {
        $(document).on('virtual_events_carousel:carousel_init', function () {
          $modules = $('.js-quickshop-carousel-slide', context);
          self.init($modules);
        });
      } else {
        self.init($modulesInit);
      }
    },
    init: function ($modules) {
      var self = this;

      $modules.each(function () {
        var $slide = $(this);
        var $icon = $slide.find('.js-quickshop-carousel-slide__icon');
        var $product = $slide.find('.js-quickshop-carousel-slide__product');
        var $shades = $slide.find('.js-quickshop-carousel-slide__shades');
        var $carousel = $shades.find('.js-quickshop-carousel-slide__shadeselectcontainer');

        if ($product.data('rating')) {
          self.calculateReviewWidth($product);
        }
        if ($shades && $shades.length > 0) {
          self.shadeCarouselInit($shades, $slide, $carousel);
        }
       
        $product.add($icon).off('click.slide').on('click.slide', function () {
          if (self.isMobile) {
            if (!$product.hasClass('active')) {
              $icon.addClass('active');
              $product.addClass('active');
            } 
          }
        });
        //Only want the close with the close icon, not product panel
        $icon.off('click.slideicon').on('click.slideicon', function () {
          if (self.isMobile) {
            if ($product.hasClass('active')) {
              $icon.removeClass('active');
              $product.removeClass('active');
            } 
          }
        })
      });
    },
    calculateReviewWidth: function ($product) {
      var rating;
      var reviewWidth = 0;

      if ($product.data('rating')) {
        rating = Number($product.data('rating'));
        reviewWidth = (rating / 5) * 100;
        $product.find('.js-quickshop-carousel-slide__reviews-starssimplifiedstars').css('width', reviewWidth + '%');
      }
    },
    shadeCarouselInit: function ($shades, $slide, $carousel) {
      var self = this;
      var shadesMove = Number($carousel.data('shadesMove')) || 1;
      var shadesShow = Number($carousel.data('shadesShow')) || 7;

      $carousel.slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToScroll: shadesMove,
        slidesToShow: shadesShow,
        rtl: site.direction.isRTL,
        variableWidth: true,
        prevArrow: '<button class="quickshop-carousel-slide__shades-arrows slide-arrow prev-arrow" aria-label="Previous" type="button"></button>',
        nextArrow: '<button class="quickshop-carousel-slide__shades-arrows slide-arrow next-arrow" aria-label="Next" type="button"></button>',
        onInit: function () {
          self.setCarouselListeners($shades, $slide);
        }
      });
    },
    setCarouselListeners: function ($shades, $slide) {
      var $displayName = $shades.find('.js-shade-select-content-display');
      var $wrappers = $shades.find('.js-shade-select-wrapper');
      var $productImage = $slide.find('.js-quickshop-carousel-slide__product-image').find('img');
      var $atb = $slide.find('.js-product-add-to-bag');
      var $wrapper;

      $wrappers.not('.slick-cloned').first().addClass('selected');
      $.each($wrappers, function () {
        $(this).off('click.shade').on('click.shade', function () {
          $wrapper = $(this);
          $wrappers.removeClass('selected');
          $wrapper.addClass('selected');
          $displayName.html($wrapper.find('.js-shade-select-content').html());
          $displayName.css('color', $wrapper.data('skuHex'))
          $productImage.attr('src', $wrapper.data('skuImg'));
          if ($atb && $atb.length > 0) {
            $atb.attr('data-sku-base-id', $wrapper.data('skuId'));
          }
        });
      });
    }
  };
})(jQuery);
